import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../components/ui/card';
import { Lock } from 'lucide-react';

export default function Privacy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#050505] pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-8" style={{ fontFamily: 'Syne, sans-serif' }}>
          {t('privacy.title')}
        </h1>

        {/* Intro Box */}
        <Card className="bg-[#F9004D]/10 border-[#F9004D]/50 p-6 mb-8">
          <div className="flex items-start gap-3">
            <Lock className="h-6 w-6 text-[#F9004D] flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold text-white mb-3">{t('privacy.intro.title')}</h2>
              <p className="text-zinc-300 leading-relaxed">
                {t('privacy.intro.p1')}
              </p>
            </div>
          </div>
        </Card>

        <div className="space-y-8">
          {/* Article 1 */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              {t('privacy.art1.title')}
            </h2>
            <div className="space-y-3 text-zinc-300">
              <p>{t('privacy.art1.intro')}</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>{t('privacy.art1.li1')}</li>
                <li>{t('privacy.art1.li2')}</li>
                <li>{t('privacy.art1.li3')}</li>
                <li>{t('privacy.art1.li4')}</li>
              </ul>
            </div>
          </Card>

          {/* Article 2 */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              {t('privacy.art2.title')}
            </h2>
            <div className="space-y-3 text-zinc-300">
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>{t('privacy.art2.li1')}</li>
                <li>{t('privacy.art2.li2')}</li>
                <li>{t('privacy.art2.li3')}</li>
                <li>{t('privacy.art2.li4')}</li>
              </ul>
            </div>
          </Card>

          {/* Article 3 */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              {t('privacy.art3.title')}
            </h2>
            <div className="space-y-3 text-zinc-300">
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>{t('privacy.art3.li1')}</li>
                <li>{t('privacy.art3.li2')}</li>
                <li><strong>{t('privacy.art3.li3')}</strong></li>
              </ul>
            </div>
          </Card>

          {/* Article 4 */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              {t('privacy.art4.title')}
            </h2>
            <div className="space-y-3 text-zinc-300">
              <p>{t('privacy.art4.intro')}</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>{t('privacy.art4.li1')}</li>
                <li>{t('privacy.art4.li2')}</li>
                <li>{t('privacy.art4.li3')}</li>
                <li>{t('privacy.art4.li4')}</li>
                <li>{t('privacy.art4.li5')}</li>
              </ul>
            </div>
          </Card>

          {/* Article 5 */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              {t('privacy.art5.title')}
            </h2>
            <div className="space-y-3 text-zinc-300">
              <p>{t('privacy.art5.p1')}</p>
            </div>
          </Card>

          {/* Contact */}
          <Card className="bg-zinc-900/50 border-white/10 p-8">
            <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              {t('privacy.contact.title')}
            </h2>
            <div className="space-y-3 text-zinc-300">
              <p>{t('privacy.contact.p1')}</p>
              <p className="text-[#00F0FF]">contact@guidematch-tokyo.com</p>
            </div>
          </Card>
        </div>

        <div className="mt-12 text-center text-zinc-500 text-sm">
          <p>{t('privacy.updated')}</p>
        </div>
      </div>
    </div>
  );
}
